/**
 * Form Validation Standalone Script
 * @description Carrega apenas o módulo de validação de formulários (window.IrrobaFormValidation)
 *              para temas fora da estrutura starter, que não carregam account.min.js.
 * @version 1.0.0
 * @author Irroba Platform
 */

import { initFormValidation } from '../form.js';

const init = () => initFormValidation('[data-validate-form], [data-account-form]');

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
